// extracted by mini-css-extract-plugin
export var addButton = "_df-0";
export var border = "_df-8";
export var check = "_df-h";
export var danger = "_df-6";
export var dropdownContainer = "_df-1";
export var editModalBody = "_df-j";
export var footerContainer = "_df-i";
export var fullWidth = "_df-a";
export var hide = "_df-9";
export var icon = "_df-3";
export var input = "_df-7";
export var inputFlex = "_df-b";
export var inputWrapper = "_df-c";
export var manualFocus = "_df-5";
export var optionButton = "_df-4";
export var pillWrapper = "_df-e";
export var pointer = "_df-2";
export var showOverflow = "_df-f";
export var tagsFlex = "_df-d";
export var xButton = "_df-g";